import {
  TRANSACTION_FETCH,
  TRANSACTION_FETCH_SUCCESS,
  TRANSACTION_FETCH_FAIL,
  TRANSACTION_SUMMARY_FETCH,
  TRANSACTION_SUMMARY_FETCH_SUCCESS,
  TRANSACTION_SUMMARY_FETCH_FAIL,
  TRANSACTION_MONTHLY_FETCH,
  TRANSACTION_MONTHLY_FETCH_SUCCESS,
  TRANSACTION_MONTHLY_FETCH_FAIL,
  TRANSACTION_MACHINETYPE_FETCH,
  TRANSACTION_MACHINETYPE_FETCH_SUCCESS,
  TRANSACTION_MACHINETYPE_FETCH_FAIL,
  TRANSACTION_CONFIRMATION_FETCH,
  TRANSACTION_CONFIRMATION_FETCH_SUCCESS,
  TRANSACTION_CONFIRMATION_FETCH_FAIL,
  TRANSACTION_BY_SERVICE_FETCH,
  TRANSACTION_BY_SERVICE_FETCH_SUCCESS,
  TRANSACTION_BY_SERVICE_FETCH_FAIL
} from '../actions';

export const transactionFetch = (transaction, history) => ({
  type: TRANSACTION_FETCH,
  payload: { transaction, history }
});
export const transactionSuccess = (transaction) => ({
  type: TRANSACTION_FETCH_SUCCESS,
  payload: transaction
});
export const transactionFail = (message) => ({
  type: TRANSACTION_FETCH_FAIL,
  payload: { message }
});

export const transactionSummaryFetch = (transactionSummary, history) => ({
  type: TRANSACTION_SUMMARY_FETCH,
  payload: { transactionSummary, history }
});

export const transactionSummarySuccess = (transactionSummary) => ({
  type: TRANSACTION_SUMMARY_FETCH_SUCCESS,
  payload: { transactionSummary }
});

export const transactionSummaryFail = (message) => ({
  type:   TRANSACTION_SUMMARY_FETCH_FAIL
,
  payload: { message }
});

export const transactionMonthlyFetch = (monthly) => ({
  type: TRANSACTION_MONTHLY_FETCH,
  payload: { monthly }
});

export const transactionMonthlySuccess = (monthly) => ({
  type: TRANSACTION_MONTHLY_FETCH_SUCCESS,
  payload: monthly
});

export const transactionMonthlyFail = (message) => ({
  type: TRANSACTION_MONTHLY_FETCH_FAIL,
  payload: { message }
});

export const transactionMachineTypeFetch = (tranMachineType) => ({
  type: TRANSACTION_MACHINETYPE_FETCH,
  payload: { tranMachineType }
});

export const transactionMachineTypeFetchSuccess = (tranMachineType) => ({
  type: TRANSACTION_MACHINETYPE_FETCH_SUCCESS,
  payload: tranMachineType
});

export const transactionMachineTypeFetchFail = (message) => ({
  type: TRANSACTION_MACHINETYPE_FETCH_FAIL,
  payload: { message }
});

export const transactionComfirmationFetch = (tranConfirm) => ({
  type: TRANSACTION_CONFIRMATION_FETCH,
  payload: { tranConfirm }
});

export const transactionComfirmationFetchSuccess = (tranConfirm) => ({
  type: TRANSACTION_CONFIRMATION_FETCH_SUCCESS,
  payload: tranConfirm
});

export const transactionComfirmationFetchFail = (message) => ({
  type: TRANSACTION_CONFIRMATION_FETCH_FAIL,
  payload: { message }
});

export const transactionByServiceFetch = (tranByService) => ({
  type: TRANSACTION_BY_SERVICE_FETCH,
  payload: { tranByService }
});

export const transactionByServiceFetchSuccess = (tranByService) => ({
  type: TRANSACTION_BY_SERVICE_FETCH_SUCCESS,
  payload: tranByService
});

export const transactionByServiceFetchFail = (message) => ({
  type: TRANSACTION_BY_SERVICE_FETCH_FAIL,
  payload: { message }
});
